<template>
	<div class="row my-1">
		<div class="col-sm-8 d-flex align-items-center">
			<input
				class="form-check-input"
				type="checkbox"
				:id="`Checkbox-${name.replace(' ', '')}`"
				:value="name.replace(' ', '')"
				v-model="data.roomChecked"
			/>
			<label
				class="form-check-label mx-2 custom-dark-text"
				:for="`Checkbox-${name}`"
				>{{ name }}</label
			>
		</div>
		<div v-if="data.roomChecked" class="col-sm-4">
			<BaseInput
				name="NumberOfRooms"
				placeholder="Number of rooms"
				type="Number"
				:min="0"
				:max="10"
				v-model="data.roomCount"
				class="form-control form-control-lg dashInput"
				rules="required"
				@valError="valError"
				@valSuccess="valSuccess"
			/>
		</div>
	</div>
</template>

<script>
	import { reactive, watch, onMounted } from "vue";
	import BaseInput from "./BaseInput";
	// import toast from "@/config/toast";
	export default {
		name: "RoomTypeAndCount",
		components: {
			BaseInput,
		},
		props: {
			name: { type: String, required: true },
			hotelId: { type: String, required: true },
			capacity: { type: [Number, String], require: true },
			price: { type: Number, require: true },
			id: { type: Number, required: true },
			defaultData: { type: [Array, Object, Boolean], default: false },
		},
		emits: ["updateData", "removeData"],
		setup: (props, { emit }) => {
			const data = reactive({
				roomChecked: false,
				roomCount: 0,
			});

			const valError = (input) => {};
			const valSuccess = (input) => {};

			watch(
				() => data,
				(preValue, newValue) => {
					if (data.roomChecked && data.roomCount) {
						emit("updateData", {
							roomType: props.name,
							roomCount: parseInt(data.roomCount, 10),
							hotelId: props.hotelId,
							price: props.price,
							capacity: props.capacity,
						});
						return;
					}
					if (!data.roomChecked && data.roomCount) {
						emit("removeData", { name: props.name, hotelId: props.hotelId });
						data.roomCount = 0;
						return;
					}
				},
				{ deep: true },
			);

			if (props.defaultData.length) {
				let selected = props.defaultData.filter(
					(item) =>
						item.roomType === props.name && item.hotelId === props.hotelId,
				);

				if (selected.length) {
					data.roomChecked = true;
					data.roomCount = selected[0].roomCount;
				}
			}

			onMounted(() => {
				if (props?.defaultData?.roomType === props.name) {
					data.roomChecked = true;
					data.roomCount = props.defaultData?.roomCount;
				}
			});

			return {
				data,
				valError,
				valSuccess,
			};
		},
	};
</script>
